import axios from "axios";
import { getImpersonatedClientId } from "../context/ImpersonationContext";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Endpoints that should be scoped by client when impersonation is active
const IMPERSONATE_SCOPED = [
    /^\/cases\/?$/,
    /^\/cases\/stats\/summary\/?$/,
];

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ll_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;

    // Auto-scope certain GETs to the impersonated client
    if ((config.method || "get").toLowerCase() === "get") {
        const path = (config.url || "").split("?")[0];
        if (IMPERSONATE_SCOPED.some((rx) => rx.test(path))) {
            const clientId = getImpersonatedClientId();
            if (clientId) {
                config.params = { ...(config.params || {}), client_id: clientId };
            }
        }
    }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    if (typeof d === "object" && d.msg) return d.msg;
    return String(d);
}

export default api;
